import React from 'react';
import { TrendingUp, Users, Activity, Trophy } from 'lucide-react';
import '../styles/StravaSegments.css';

const StravaSegments = ({ segments }) => {
  if (!segments || segments.length === 0) {
    return (
      <div className="strava-segments-container">
        <div className="no-segments">
          <Activity size={48} />
          <p>No s'han trobat segments de Strava a la zona</p>
        </div>
      </div>
    );
  }

  const formatTime = (seconds) => {
    if (!seconds) return null;
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}s`;
  };

  const getClimbCategory = (category) => {
    const categories = {
      0: { label: 'Pla', color: '#22c55e' },
      1: { label: 'Cat 4', color: '#84cc16' },
      2: { label: 'Cat 3', color: '#eab308' },
      3: { label: 'Cat 2', color: '#f97316' },
      4: { label: 'Cat 1', color: '#ef4444' },
      5: { label: 'HC', color: '#991b1b' },
    };
    return categories[category] || categories[0];
  };

  return (
    <div className="strava-segments-container fade-in">
      <div className="strava-header">
        <img
          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 24 24'%3E%3Cpath fill='%23fc4c02' d='M15.387 17.944l-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066m-7.008-5.599l2.836 5.598h4.172L10.463 0L0 17.944h6.121'/%3E%3C/svg%3E"
          alt="Strava"
          width="32"
          height="32"
        />
        <div>
          <h3>Segments Populars de Strava</h3>
          <p className="strava-subtitle">{segments.length} segments trobats</p>
        </div>
      </div>

      <div className="segments-list">
        {segments.map((segment, index) => {
          const climbInfo = getClimbCategory(segment.climb_category);

          return (
            <div key={segment.id || index} className="segment-item">
              <div className="segment-rank">#{index + 1}</div>

              <div className="segment-content">
                <div className="segment-header-row">
                  <h4>
                    {segment.start_km !== undefined && (
                      <span style={{color: '#666', marginRight: '8px', fontSize: '0.9em'}}>KM {segment.start_km}</span>
                    )}
                    {segment.name || "Segment sense nom"}
                    {segment.direction && (
                      <span className={`segment-direction ${segment.direction === '←' ? 'reverse' : 'forward'}`}>
                        {segment.direction}
                      </span>
                    )}
                  </h4>
                  <span className="climb-category" style={{ backgroundColor: climbInfo.color }}>
                    {climbInfo.label}
                  </span>
                </div>

                <div className="segment-stats">
                  <div className="stat-item">
                    <Activity size={16} />
                    <span>{(segment.distance || 0).toFixed(0)}m</span>
                  </div>

                  <div className="stat-item">
                    <TrendingUp size={16} />
                    <span>{(segment.avg_grade || 0).toFixed(1)}%</span>
                  </div>

                  {segment.kom_time_sec && (
                    <div className="stat-item">
                      <Trophy size={16} color="#f59e0b" />
                      <span>{formatTime(segment.kom_time_sec)}</span>
                    </div>
                  )}

                  {/* Mostrem intents només si la dada existeix */}
                  {segment.effort_count !== undefined && (
                    <div className="stat-item">
                      <Users size={16} />
                      <span>{segment.effort_count.toLocaleString()} intents</span>
                    </div>
                  )}
                </div>

                {/* Coordenades amb protecció (si no hi són, no es mostra el div) */}
                {segment.start_lat && segment.start_lon && (
                  <div className="segment-coordinates">
                    📍 Inici: {segment.start_lat.toFixed(5)}, {segment.start_lon.toFixed(5)}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StravaSegments;